import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs, Tab, Box } from '@mui/material'
import { useIsCompact } from '@/hooks/useLayoutMode'
import { MainContentArea } from '@/components/layout/MainContentArea'
import { CustomViewsManager } from '@/components/user-content/CustomViewsManager'
import { BookmarksManager } from '@/components/user-content/BookmarksManager'
import { NotesManager } from '@/components/user-content/NotesManager'
import { SettingsManager } from '@/components/user-content/SettingsManager'

interface TabPanelProps {
  children?: React.ReactNode
  value: number
  index: number
}

function TabPanel({ children, value, index }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`user-content-tabpanel-${index}`}
      aria-labelledby={`user-content-tab-${index}`}
      className="user-content-tabpanel"
    >
      {value === index && <div className="user-content-tabpanel-content">{children}</div>}
    </div>
  )
}

export function UserContentPage() {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState(0)
  const isCompact = useIsCompact()

  return (
    <MainContentArea>
      <div className="user-content-page">
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={activeTab}
            onChange={(_e, newValue) => setActiveTab(newValue)}
            aria-label={t('userContent.tabsAriaLabel')}
            variant={isCompact ? 'scrollable' : 'standard'}
            scrollButtons={isCompact ? 'auto' : false}
            allowScrollButtonsMobile
            sx={{
              '& .MuiTab-root': { textTransform: 'none', fontWeight: 600, fontSize: 14 },
            }}
          >
            <Tab label={t('userContent.tabCustomViews')} id="user-content-tab-0" aria-controls="user-content-tabpanel-0" />
            <Tab label={t('userContent.tabBookmarks')}   id="user-content-tab-1" aria-controls="user-content-tabpanel-1" />
            <Tab label={t('userContent.tabNotes')}       id="user-content-tab-2" aria-controls="user-content-tabpanel-2" />
            {/*<Tab label={t('userContent.tabSettings')}    id="user-content-tab-3" aria-controls="user-content-tabpanel-3" />*/}
          </Tabs>
        </Box>

        <TabPanel value={activeTab} index={0}>
          <CustomViewsManager />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <BookmarksManager />
        </TabPanel>
        <TabPanel value={activeTab} index={2}>
          <NotesManager />
        </TabPanel>
        <TabPanel value={activeTab} index={3}>
          <SettingsManager />
        </TabPanel>
      </div>
    </MainContentArea>
  )
}
